import { render } from "./App.vue?vue&type=template&id=14a107b4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=14a107b4&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__